import Corporation from '../../types/Corporation';

export default interface Corp {
    name: string;
    corpCode: string;
    token: string;
    settings: Corporation.Settings;
}

export const corpTransformer = (corp: Corporation.Base): Corp => {
    return <Corp>{
        name: corp.name,
        corpCode: corp.sCorpCode,
        token: corp.token,
        settings: corp.settings,
    };
};
